import React, { Component } from "react";
import ReactAudioPlayer from "react-audio-player";

class Backsound extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <ReactAudioPlayer
          src={this.props.musicurl}
          controls
          style={{ height: `2rem` }}
        />
      </div>
    );
  }
}

export default Backsound;
